import React from 'react';
import { connect} from 'react-redux';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

import { WithTranslation, withTranslation, Trans } from 'react-i18next';
import { DialogContentText } from '@material-ui/core';
import { IPageState, AppState } from '../../appredux';
import { GRAFIK_DNI } from 'App';

export type Content = {
    message: string,
    messageBoldPrimary?: string,
}

interface DialogProps extends WithStyles<typeof styles>, WithTranslation {
    page: IPageState,

    randomNum: number,
    okCallback: () => void,
}

interface DialogState {
    open: boolean
}

class Notifier extends React.Component<DialogProps, DialogState> {

    constructor(props: DialogProps) {
        super(props, {});
        this.state = {
            open: true
        }
    }

    componentDidUpdate(prevProps: DialogProps) {
        if(this.props.randomNum !== prevProps.randomNum){
            this.setState({open: true})
        }
    }

    closeDialog = () => {
        this.setState({ open: false });
    };

    okCallback = () => {
        this.props.okCallback()
        this.closeDialog()
    }

    render() {
        const { classes } = this.props;

        let dateF = new Date(this.props.page.dateFrom)
        let dateTo = new Date(dateF.setDate(dateF.getDate() + GRAFIK_DNI)).toISOString().substring(0, 10)

        return (
            <Dialog
                maxWidth="xs"
                open={this.state.open}
                onClose={this.closeDialog}
                fullWidth
            >
                <DialogTitle disableTypography>
                    <Typography gutterBottom variant="h5" component="h2" color="primary" style={{ fontSize: "1.25rem", textTransform: "lowercase" }}>
                        <b><Trans>Choose</Trans></b>
                    </Typography>
                    <hr style={{borderStyle: "none none solid none", borderBottom: "1px solid #e0e0e0", marginBlockStart: "2px"}} />
                </DialogTitle>
                <DialogContent>
                        <DialogContentText color="primary" style={{ marginBottom: "0" }}>
                            {/* Brak wolnych pokoi w terminie <b>{this.props.page.dateFrom}</b> - <b>{dateTo}</b> */}
                            W terminie <b style={{whiteSpace: "pre"}}>{this.props.page.dateFrom}</b> / <b style={{whiteSpace: "pre"}}>{dateTo}</b>
                        </DialogContentText>
                        <DialogContentText color="primary" style={{  }}>
                            {/* Brak wolnych pokoi w terminie <b>{this.props.page.dateFrom}</b> - <b>{dateTo}</b> */}
                            brak dostępnych pokoi.
                        </DialogContentText>
                        <DialogContentText color="primary" style={{  }}>
                            Czy znaleźć pierwszy wolny termin?
                        </DialogContentText>


                    {/* {this.props.dialogContent.map((text, index) => (
                        <DialogContentText key={index} color="primary" style={{ paddingLeft: text.message.includes("*") ? "12px" : "0", minHeight: "24px", fontSize: this.props.windowWidth < 600 ? "0.9rem" : "1rem" }}>
                            {text.message}
                            {text.messageBoldPrimary ?
                                <b className={classes.primary}>{text.messageBoldPrimary}</b> : null}
                        </DialogContentText>
                    ))} */}



                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" color="primary" size="small" style={{ textTransform: "none" }}
                        onClick={this.closeDialog}
                    >
                        <b><Trans>Back</Trans></b>
                    </Button>
                    <Button variant="contained" color="primary" size="small"
                        onClick={this.okCallback}
                    >
                        <b>OK</b>
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

const styles = (theme: Theme) => ({
    textAlignLeft: {
        textAlign: 'left' as 'left',
    },
    fontWeightNormal: {
        fontWeight: 'normal' as 'normal',
    },
    uppercase: {
        textTransform: "uppercase" as "uppercase"
    },
    input: {
        backgroundColor: '#ffffff',
        color: "rgb(0, 0, 0)"
    },
    primary: {
        color: theme.palette.primary.main
    },
});


const mapStateToProps = (state: AppState) => ({
    page: state.pageState,
});

export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(Notifier)));